angular.module('directives.favorites', [])
  .directive('favoriteToggle', function() {
    return {
      restrict: 'E',
      template:
        '<div class=\'btn btn-sm btn-line-default on-gray-bg\' ng-click="toggle()">' +
          '<i class=\'fal icon-star\' ng-class=\'{' +
            '"text-orange-devex": item.is_favorite}\'' +
            'title="mark as favorite"/>' +
          '<span ng-class=\'{"text-orange-devex": item.is_favorite}\' ' +
          'ng-bind=\'item.is_favorite ? "Saved" : "Save"\'/>' +
        '</div>',
      scope: {
        item: '=',
        onToggle: '&'
      },
      link: function (scope) {
        scope.toggle = function() {
          if (scope.onToggle) {
            scope.onToggle(scope.item);
          }
        };
      }
    };
  });
